var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcn3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 67 67",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0066FF",
    d: "M59.4,7.6c-1.3-1.3-3.5-1.4-6.4-0.4c-2,0.7-4.1,1.9-5.1,2.9l-8.1,8.1l-26.5-4.2l-6.8,6.8l22.1,8.6l-7.1,7.1 l-10.1,0.6L6.6,42l10.9,5.3l-3.1,3.1l2.2,2.2l3.1-3.1L25,60.4l4.8-4.8l0.6-10.1l7.2-7.2l8.6,22.1l6.8-6.8l-4.2-26.5l7.9-7.9 c1-1,2.2-3.1,2.9-5.1C60.8,11.1,60.7,8.9,59.4,7.6z M12.2,19.7l2.2-2.2L37.1,21l-6,6L12.2,19.7z M49.7,52.5l-2.2,2.2l-7.4-18.9l6-6 L49.7,52.5z M56.8,13c-0.6,1.7-1.6,3.4-2.2,3.9L27.4,44.1l-0.6,10.1L26,55l-3.8-7.9l2.8-2.8l-2.2-2.2l-2.7,2.7L12,41.1l0.8-0.8 l10.1-0.6l27.2-27.2c0.6-0.6,2.2-1.6,3.9-2.2C56,9.6,57,9.7,57.2,9.9C57.3,10,57.5,11.1,56.8,13z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn3);
export default __webpack_public_path__ + "static/media/icn_3.de47f195da230638b40f91c63ddfbe0c.svg";
export { ForwardRef as ReactComponent };